/**
 * @description Component-TradeHistoryDrawer
 */
import './index.less';

import React, { FC, useCallback, useState } from 'react';

import SubPageWrap from '@/components/SubPage';
import { HISTORY_TYPE } from '@/constants/history';
import { useCurrentPairFromUrl } from '@/features/pair/hook';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';

import {
  useInfiniteAccountBalanceHistory,
  useInfiniteFundingHistory,
  useInfiniteLiquidityHistory,
  useInfiniteOrdersHistory,
  useInfiniteTransferHistory,
  useInfiniteVirtualTradeHistory,
} from '@/features/graph/hooks';
import HistoryDrawerHeader from '../../components/HistoryDrawerHeader';
import MobileHistory from '../../components/MobileHistory';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  open: boolean;

  onClose: () => void;
  isTradePage?: boolean;
}
const TradeHistoryDrawer: FC<IPropTypes> = function ({ open, onClose, isTradePage }) {
  const [tab, setTab] = useState(HISTORY_TYPE.TRADE);
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const currentPair = useCurrentPairFromUrl(chainId);

  const { refreshData: refreshTradeHistory } = useInfiniteVirtualTradeHistory({ chainId, userAddr, pair: currentPair });
  const { refreshData: refreshOrderHistory } = useInfiniteOrdersHistory({ chainId, userAddr, pair: currentPair });
  const { refreshData: refreshFundingHistory } = useInfiniteFundingHistory({ chainId, userAddr, pair: currentPair });
  const { refreshData: refreshLiquidityHistory } = useInfiniteLiquidityHistory({
    chainId,
    userAddr,
    pair: currentPair,
  });
  const { refreshData: refreshTransferHistory } = useInfiniteTransferHistory({ chainId, userAddr, pair: currentPair });
  const { refreshData: refreshAccountHistory } = useInfiniteAccountBalanceHistory({ chainId, userAddr });

  const refreshData = useCallback(() => {
    if (tab === HISTORY_TYPE.TRADE) {
      refreshTradeHistory();
    }
    if (tab === HISTORY_TYPE.ORDERS) {
      refreshOrderHistory();
    }
    if (tab === HISTORY_TYPE.FUNDING) {
      refreshFundingHistory();
    }
    if (tab === HISTORY_TYPE.LIQUIDITY) {
      refreshLiquidityHistory();
    }
    if (tab === HISTORY_TYPE.TRANSFERS) {
      refreshTransferHistory();
    }
    if (tab === HISTORY_TYPE.ACCOUNT) {
      refreshAccountHistory();
    }
  }, [
    tab,
    refreshFundingHistory,
    refreshOrderHistory,
    refreshTradeHistory,
    refreshLiquidityHistory,
    refreshTransferHistory,
    refreshAccountHistory,
  ]);

  return (
    <SubPageWrap
      className="syn-trade-history-drawer"
      isShowSubPage={open}
      header={<HistoryDrawerHeader onRefresh={refreshData} onClose={onClose} />}
      onClose={() => {
        console.log('');
      }}>
      <MobileHistory historyType={tab} setHistoryType={setTab} isTradePage={isTradePage} />
    </SubPageWrap>
  );
};

export default TradeHistoryDrawer;
